import React, {Component} from "react";
import {Alert, FormGroup, Row, Col, Modal, Button} from "reactstrap";
import {Formik, Form} from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import {groupPermissionsNew, groupPermissionsEdit, groupPermissionsTypesList} from "../../../store/groups/permissions/actions";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import SelectField from "../../../components/Common/SelectField";
import {capitalizeFirst, removeEmptyFormField} from "../../../common/general";

class NewModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      permissionsTypesData: [],
      selectedType: this.props.action === "new" ? null : this.props.permissionData.type,
      loading: false,
      error: "",
    }
  }

  componentDidMount() {
    const {onGroupPermissionsTypesList} = this.props;
    onGroupPermissionsTypesList({history: this.props.history, groupId: this.props.groupId});
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      let types = []
      if (this.props.responseTypes) {
        types = this.props.responseTypes.response
        if (this.props.action === "edit")
          types = [this.state.selectedType, ...types]
      }
      this.setState({
        permissionsTypesData: types,
        loading: this.props.loading,
        error: this.props.error
      });
      if (this.props.responseNew.status === 0) {
        this.props.refreshParent()
        this.onClose()
      }
    }
  }

  onClose = () => {
    this.props.togModal()
  }

  render(pleaseChooseType = "Please Choose Type") {
    return (<React.Fragment>
      <Modal isOpen={true} toggle={this.onClose}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">
            {capitalizeFirst(this.props.action)} Permission
          </h5>
          <button type="button" onClick={this.onClose} className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <Formik
          initialValues={{
            type: this.props.action === "new" ? null : this.state.selectedType,
          }}
          validationSchema={Yup.object().shape({
            type: Yup.object().typeError("Choose a Type")
          })}
          onSubmit={values => {
            const {onGroupPermissionsNew, onGroupPermissionsEdit} = this.props
            if (this.props.action === "new") {
              onGroupPermissionsNew({history: this.props.history, groupId: this.props.groupId, values: {type: values.type.value}})
            } else {
              onGroupPermissionsEdit({history: this.props.history, groupId: this.props.groupId, permissionId: this.props.permissionData.id, values: {type: values.type.value}})
            }
          }}
        >
          {() => (<Form>
            <div className="modal-body">
              <Row>
                <Col lg="12" className="mb-1">
                  <FormGroup>
                    <SelectField label="Type" name="type" options={this.state.permissionsTypesData}/>
                  </FormGroup>
                </Col>
              </Row>
            </div>
            <div className="modal-footer">
              {this.state.loading && (<div className="spinner-border text-primary m-1 me-auto" role="status">
                <span className="sr-only">Loading...</span>
              </div>)}
              {this.state.error.length > 0 && (<Alert color="danger" role="alert" className="me-auto">
                {this.state.error}
              </Alert>)}
              <Button color="secondary" onClick={this.onClose} data-dismiss="modal">
                Close
              </Button>
              <Button color="primary" type="submit">
                Save
              </Button>
            </div>
          </Form>)}
        </Formik>
      </Modal>
    </React.Fragment>)
  }
}

NewModal.propTypes = {
  responseTypes: PropTypes.any,
  responseNew: PropTypes.any,
  onGroupPermissionsTypesList: PropTypes.func,
  onGroupPermissionsNew: PropTypes.func,
  onGroupPermissionsEdit: PropTypes.func,
};

const mapStateToProps = ({GroupPermissions}) => ({
  responseTypes: GroupPermissions.responseTypesList,
  responseNew: GroupPermissions.responseNew,
  loading: GroupPermissions.loadingNew,
  error: GroupPermissions.errorNew,
});

const mapDispatchToProps = dispatch => ({
  onGroupPermissionsTypesList: data => dispatch(groupPermissionsTypesList(data)),
  onGroupPermissionsNew: data => dispatch(groupPermissionsNew(data)),
  onGroupPermissionsEdit: data => dispatch(groupPermissionsEdit(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(NewModal));